// components/user/lead/calculator/DeviceAgeSelector.jsx
import React from "react";
import { Card, Typography } from "antd";
import { ClockCircleOutlined, CheckOutlined } from "@ant-design/icons";

const { Text } = Typography;

const DeviceAgeSelector = ({ deviceAge, ageRanges, onSelect, isDarkMode }) => {
  const ageOptions =
    ageRanges && ageRanges.length > 0
      ? ageRanges.map((range) => ({
          value: range.key,
          label: range.label,
        }))
      : [
          { value: "below_1_year", label: "Below 1 Year" },
          { value: "1_to_2_years", label: "1 to 2 Years" },
          { value: "2_to_3_years", label: "2 to 3 Years" },
          { value: "above_3_years", label: "Above 3 Years" },
        ];

  const cardBg = isDarkMode ? "bg-gray-800" : "bg-white";

  return (
    <Card
      className={`${cardBg} shadow-sm rounded-lg border-0`}
      bordered={false}
      size="small"
      styles={{
        body: { padding: "14px" },
      }}
    >
      {/* Compact Header */}
      <div className="flex items-center gap-2 mb-3">
        <div className="flex items-center justify-center w-8 h-8 bg-green-500 rounded">
          <ClockCircleOutlined className="text-sm text-white" />
        </div>
        <Text
          strong
          className={`text-sm ${isDarkMode ? "text-white" : "text-gray-800"}`}
        >
         Select Device Age
        </Text>
      </div>

      {/* Age Options Grid */}
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-4">
        {ageOptions.map((option, index) => {
          const isSelected = deviceAge === option.value;

          return (
            <div
              key={option.value}
              onClick={() => onSelect(option.value)}
              className={`
                relative px-3 py-5 rounded-lg cursor-pointer
                ${
                  isSelected
                    ? "border-2 border-green-500 bg-green-50 dark:bg-green-900/20"
                    : isDarkMode
                      ? "border border-gray-600 bg-gray-700"
                      : "border border-gray-200 bg-gray-50"
                }
              `}
            >
              <div className="flex flex-col items-center gap-1.5 text-center">
                <Text
                  className={`text-sm font-semibold ${
                    isSelected
                      ? "text-green-600 dark:text-green-400"
                      : isDarkMode
                        ? "text-gray-300"
                        : "text-gray-800"
                  }`}
                >
                  {option.label}
                </Text>
              </div>

              {isSelected && (
                <div className="absolute -top-1.5 -right-1.5 w-5 h-5 rounded-full bg-green-500 flex items-center justify-center">
                  <CheckOutlined className="text-white text-[10px]" />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </Card>
  );
};

export default DeviceAgeSelector;
